import React, { useMemo, useCallback } from "react";
import { Form, Select } from "antd";
import { UserType } from "@/utils/enum";
import { Validator } from "@/utils/validator";

const { Option } = Select;

export default function RoleForm({
  formRef,
  dispatch,
  userData,
  userId,
  roles,
  setEditUserRoleVisible,
  userType,
  page = 1,
  pageSize = 10,
}) {
  const initialValues = useMemo(
    () => ({
      roles: userData?.roles?.map(role => role.id) ?? [],
    }),
    [userData?.roles],
  );

  const onSubmit = useCallback(
    ({ roleIds }) => {
      const dispatchType =
        userType === UserType.Transporter ? "singleTransporterSettings/editUserRole" : "singleDealer/editUserRole";

      const payload = {
        roleIds,
        entityId: userData?.id,
        userId,
      };

      dispatch({
        type: dispatchType,
        payload,
        page,
        pageSize,
      }).then(() => {
        formRef.resetFields();
        setEditUserRoleVisible(false);
      });
    },
    [userType, userData, userId, page, pageSize, setEditUserRoleVisible, dispatch, formRef],
  );

  return (
    <Form form={formRef} onFinish={onSubmit} initialValues={initialValues}>
      <Form.Item name="roleIds" label="Roles" rules={[Validator.required("Please select at least one role")]}>
        <Select
          placeholder="Roles"
          mode="multiple"
          filterOption={(input, option) => option.key.toLowerCase().indexOf(input.toLowerCase()) !== -1}
        >
          {roles.map(role => (
            <Option key={`${role.id}${role.name}`} value={role.id}>
              {role.name}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </Form>
  );
}
